import Vue from 'vue'
import VueRouter from 'vue-router'
import Table from '../views/Table.vue'
import store from "@/vuex/store";
import Login from "../views/Login";
import Account from "@/views/Account";
import Admin from "@/views/Admin";
import UserEdit from "@/views/UserEdit";
import analyticsCount from "@/views/analyticsCount";
import {isAdmin} from "@/router/accessRights";


Vue.use(VueRouter)

const routes = [
    {
        path: "*",
        component: {render: (h,) => h("div", ["404! Page Not Found!"])},
        name: 'Error',
    },
    {
        path: '',
        name: 'Table',
        component: Table,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/account',
        name: 'Account',
        component: Account,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin',
        name: 'Admin',
        component: Admin,
        meta: {
            requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
            isAdmin(to, from, next)
        }
    },
    {
        path: '/userEdit/:id',
        name: 'UserEdit',
        component: UserEdit,
        meta: {
            requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
            isAdmin(to, from, next)
        }
    },
    {
        path: '/analyticsCount',
        name: 'analyticsCount',
        component: analyticsCount,
        meta: {
            requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
            isAdmin(to, from, next)
        }
    },


]

const router = new VueRouter({

    routes,
    mode: 'history',
    linkExactActiveClass: "active",


})
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            if (to.path === '/login' || to.path === '/restore-password' || to.path === '/create-account') {
                next({name: "Table"})
            } else {
                next()
            }
            return
        }

        next('/login')
    } else {
        next()
    }
})

export default router
